module.exports = __webpack_public_path__ + "img/yszc-gs.9faa1057.png";